query BannerFile($id: ID!) {
  file: banner(id: $id) {
    id
    url
  }
}
